<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="520px"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="答案" prop="title">
        <el-input v-model="form.title" placeholder="请输入题目答案" />
      </el-form-item>


    </el-form>

    <div slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {MessageError, MessageWarning,MessageSuccess} from "@custom/message";
  import { detailFeedbackApi,updateFeedbackApi,addFeedbackApi } from "@/api/online-survey";
export default {
  name: "LayerQuestionDialog",
  props: {
    scopeOptions: {
      type: Array,
      default: () => []
    },
    editForm: {
      type: Object,
      default: null
    }
  },
  data() {
    const typeMapList = [
      { label: "单选题", code: 801301 },
      { label: "多选题", code: 801302 },
      { label: "填空题", code: 801303 }
    ];
    return {
      dialogVisible: false,
      typeTitle: "add",
      typeMapList,
      superUuid:"",
      form: {
        title: "",
        topicType: '',
        required: false,
        options: []
      },
      rules: {
        title: [
          { required: true, message: "请输入题目答案", trigger: "blur" }
        ],
      },
      communityList: []
    };
  },
  computed: {
    dialogTitle() {
      return this.typeTitle === "add" ? "新增答案" : "修改答案";
    }
  },
  watch: {
    "form.topicType"() {
      this.form.options = [];
    }
  },
  methods: {
   async openDialog(type, row) {
      this.typeTitle = type;
      this.resetForm();
      console.log('row',row);   
      this.form.topicType = row.topicType
      this.uuid = row.uuid; //当前行uuid
      this.superUuid = row.superUuid; //当前行uuid 
      if(this.typeTitle !=='add'){
       await this.handleSurveyInfo();
      }
      this.dialogVisible = true;
      
    },
    // 请求问卷详情
   async handleSurveyInfo() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    await  detailFeedbackApi({ uuid: this.uuid })
        .then(res => {
          this.form.comment = res.info.comment;
          this.form.title = res.info.title;
          this.form.topicType = res.info.children[0].topicType;
          this.form.required = res.info.children[0].required;
          
          // 后端返回作答数据后赋值 answerMap
          // this.answerMap = {
          //   填空uuid: "文字",
          //   单选uuid: "A.xxx",
          //   多选uuid: ["A.xxx", "B.xxx"]
          // }
          loading.close()
        })
        .catch(() => loading.close());
    },    
    resetForm() {
      this.form = {
        title: "",
        topicType: '',
        required: false,
        options: []
      };
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },

    handleClose() {
      this.dialogVisible = false;
    },

    handleSubmit() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        // 组装后端需要的完整参数
        const submitParams = {
          superUuid:this.superUuid,
          title: this.form.title,
          nodeType: 801254,//答案
          topicType: this.form.topicType,
          required: true,
          // 选项数组每一项包裹nodeType=801253
          // optionList: this.form.options.map(item => ({
          //   nodeType: 801253,
          //   topicType: this.form.topicType,
          //   title: item
          // }))
        };
        console.log('submitParams',submitParams);
        const loading = this.$loading({lock: true, text: 'Loading', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)'});
         // 判断是否编辑：存在uuid则走更新接口，否则新增
          if (this.typeTitle !=='add') {
            // 修改追加uuid参数
            submitParams.uuid = this.uuid
            console.log('submitParams',submitParams);   
            updateFeedbackApi(submitParams)
              .then(res => {
                MessageSuccess('修改成功');
                this.handleClose();
                this.$emit('handleSearch');
              })
              .catch(err => {
                // 可选：失败提示
                MessageError('修改失败')
              })
              .finally(() => loading.close());
          }else{
            submitParams.superUuid = this.uuid
            console.log('submitParams',submitParams);
            addFeedbackApi(submitParams).then(res => {
              MessageSuccess('添加成功');
              this.handleClose();
             this.$emit('handleSearch');
            }).finally(() => loading.close());
          }  

        // 抛出组装好的参数给父组件调接口
        // this.$emit("submit", submitParams);
      });
    },

    handleChangeType(code) {
      this.form.topicType = code;
    },

    addOption() {
      const index = this.form.options.length;
      const prefix = String.fromCharCode(65 + index);
      this.form.options.push(prefix + ".");
    },

    removeOption(index) {
      if (this.form.options.length <= 1) return;
      this.form.options.splice(index, 1);
    }
  }
};
</script>

<style scoped>
.type-group {
  display: flex;
  gap: 10px;
}
.type-btn {
  padding: 6px 16px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
}
.type-btn.active {
  border-color: #409eff;
  background: #ecf5ff;
  color: #409eff;
}
.option-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 8px;
}
.option-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.add-option-btn {
  padding-left: 0;
}
</style>